import { 가족장2026 } from "./가족장";
import { 무빈소장2026 } from "./무빈소장";
import { 일반장2026 } from "./일반장";
// import { VIP장 } from "./VIP장";
export interface Detail {
  key: "인력" | "용품" | "차량" | "희망하시는 경우 용품을 변경할 수 있습니다";
  contents: {
    src: string;
    title: string;
    price: number;
    discountPrice?: number | string;
    type?: string;
    descriptions: string;
  }[];
}

export interface Step {
  src: string;
  title: string;
  description: string;
}

export interface ServiceDetails {
  type: "VIP장" | "일반장" | "가족장" | "무빈소장";
  description: string;
  recommendationText: string;
  정상가: number;
  가격: number;
  최종할인가?: number;
  조문객: string;
  빈소: string;
  접객도우미: string;
  "장례 용품": string;
  "장의 차량": number;
  details: Detail[];
  extraDetails?: Detail[];
  steps: [Step[], Step[], Step[]];
  deductions: string[];
  extra: string[];
}

export type ExtraDetailKey = "차량" | "유골함" | "수의" | "매장용품";

interface ExtraDetail {
  key: string;
  contents: Partial<Record<ExtraDetailKey, ExtraItem[]>>;
}

export interface ExtraItem {
  src: string;
  title: string;
  descriptions: string;
  price: number;
  type?: string;
  discountPrice?: number;
}

export type Service2026Type = "일반장" | "가족장" | "무빈소장";
// | "가족장 프리미엄"
// | "일반장 프리미엄";

export interface Service2026Details {
  type: Service2026Type;
  packageKey?: string;
  // backgroundColor: string;
  // mainColor: string;
  // subColor: string;
  // imageSrc: string;

  description: string;
  summary: string;
  recommendationText: string;
  정상가: number;
  가격: number;
  최종할인가?: number;
  조문객: string;
  빈소: string;
  접객도우미: string;
  "장례 용품": string;
  "장의 차량": number;
  details: Detail[];
  extraDetails?: ExtraDetail[];
  steps: [Step[], Step[], Step[]];
  deductions: string[];
  extra: string[];
}

export const SERVICE_DETAILS: Record<
  Service2026Details["type"],
  Service2026Details
> = {
  일반장: 일반장2026,
  가족장: 가족장2026,
  무빈소장: 무빈소장2026,
};
